import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { useContent } from "../../context/ContentContext";

export default function Faq() {
  const { content } = useContent();
  const FAQS = content.faqs;
  return (
    <section className="py-20 lg:py-28 bg-homi-light">
      <div className="max-w-3xl mx-auto px-6">
        <div className="text-center mb-12">
          <span className="homi-section-tag text-homi-goldDark text-sm">FAQ</span>
          <h2 className="font-heading font-extrabold text-3xl md:text-4xl lg:text-5xl text-homi-black mt-3">Frequently Asked Questions</h2>
        </div>
        <Accordion type="single" collapsible className="space-y-4">
          {FAQS.map((f, i) => (
            <AccordionItem key={f.q} value={`item-${i}`} className="bg-white rounded-xl border border-gray-100 px-6">
              <AccordionTrigger className="font-heading font-bold text-homi-black text-left hover:no-underline py-5">{f.q}</AccordionTrigger>
              <AccordionContent className="text-homi-body leading-relaxed pb-5">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
